import { useContext } from "react";

import { SlideDataContext } from "../contexts/slideDataContext";
import { Age, Profile, QuestionId } from "@common";
import { useSettings } from "@natklok/hooks/useSettings";
import { useNavigate } from "react-router-dom";
import useDefaultSlideDatas from "./useDefaultSlideDatas";

const useGenerateOneQuestionQuiz = () => {
  const { questionsReducer } = useContext(SlideDataContext);
  const settings = useSettings();
  const navigate = useNavigate();
  const defaultSlideDatas = useDefaultSlideDatas();

  const generateOneQuestionQuiz = (
    questionId: QuestionId,
    age: Age = settings.age,
    profiles: Profile[] = settings.profiles
  ) => {
    questionsReducer({
      type: "generateOneQuestionQuiz",
      age,
      profiles,
      questionId,
      defaultSlideDatas,
    });
    navigate("/questions");
  };

  return generateOneQuestionQuiz;
};

export default useGenerateOneQuestionQuiz;
